export default __webpack_public_path__ + "static/media/box5.29f4cf44.JPG";